














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponetsOrdersComponetsOrderChildren extends Vue {
  @Prop({ type: Array, default: () => [] })
  items: Array<any>;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/orders/OrderChildren.vue